// Report sectioning for the Salary Statement. Sections are driven entirely by
// each employee's assigned Employee Group (admin-configurable, see the
// "Groups" tab in Admin Portal).
//
// "PF" is an ordinary Employee Group like any other - there's no separate
// flag or special-casing here. An employee assigned to that group simply
// lands in a section literally named "PF", which SalaryStatement.jsx (and
// salaryStatementExcel.js) key off of by name to render the alternate
// Basic/PF/ESI/Total Payable Salary column layout. Renaming or deleting
// that group in Pay Groups admin is blocked backend-side specifically so
// this string can't silently drift out of sync with the real group again.
export const PF_ENABLED_GROUP_NAME = 'PF'

function normalize(value) {
  return String(value).trim().toLowerCase()
}

// Groups rows by their assigned Employee Group name - every row is expected
// to already have a `group` value, since the backend only returns employees
// who have an Employee Group assigned.
//
// `groupOrder` (optional) is the list of group names in the order configured
// on the "Pay Groups" admin tab (see AdminDashboard.js's GroupsTab) - pass it
// whenever it's available so sections follow that order everywhere (Salary
// Statement webpage and its Excel export both read this same output).
// Falls back to alphabetical for any group not present in `groupOrder` (e.g.
// while it's still loading), so nothing is ever silently dropped.
export function groupRowsByEmployeeGroup(rows, groupOrder = []) {
  const present = Array.from(new Set(rows.map((row) => row.group)))
  const known = groupOrder.filter((name) => present.includes(name))
  const unknown = present
    .filter((name) => !groupOrder.includes(name))
    .sort((a, b) => normalize(a).localeCompare(normalize(b)))
  const groupNames = [...known, ...unknown]

  return groupNames.map((name) => ({
    name,
    rows: rows
      .filter((row) => row.group === name)
      .sort((a, b) => (
        normalize(a.department).localeCompare(normalize(b.department))
        || normalize(a.employee).localeCompare(normalize(b.employee))
      )),
  }))
}
